'use strict';

const Enum = require('./enum');

/**
 * Defines notification events
 *
 * @enum
 * @readonly
 */
exports.NotificationEvents = Object.create(Enum, {
  ONLINE: { value: 'online', enumerable: true },
  OFFLINE: { value: 'offline', enumerable: true },
  // notification event for window actuator system
  OBSTRUCTION_DETECTED: { value: 'obstruction_detected', enumerable: true },
});
